import React, { useState } from 'react'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    IconButton,
    Button,
    Icon,
    Flex,
    Tooltip,
} from '@chakra-ui/react'
import { useDispatch } from 'react-redux';
import { MdDelete } from 'react-icons/md';
import { AiOutlineAlert } from 'react-icons/ai';
import { deleteFactura, getFacturas } from '../../features/facturaVentaSlice';
import { ToastChakra } from '../../helpers/toast';


export const AlertEliminarFactura = ({ row, page, perPage }) => {

    const dispatch = useDispatch();

    const [isOpenAlert, setIsOpenAlert] = useState(false);

    const handleOpenAlert = () => {

  // Verifica si el estado es "PENDIENTE"
    if (row.estado === "ACTIVO") {
        ToastChakra(
            "Acción no permitida",
            "Solo se pueden eliminar facturas en estado PENDIENTE o ANULADO.",
            "warning",
            4000,
            "bottom-right"
        );
        return; // Detiene la ejecución si el estado no es "PENDIENTE"
    }
   /* else if (row.estado === "ANULADO") {
        ToastChakra(
            "Acción no permitida",
            "No se puede eliminar una factura anulada.",
            "warning",
            4000,
            "bottom-right"
        );
        return; // Detiene la ejecución si el estado no es "PENDIENTE"
        
    }*/

        setIsOpenAlert(true);
    }

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    }

    const handleDelete = (id) => {
        dispatch(deleteFactura(id)).then(() => {
            dispatch(getFacturas({ page, perPage })); // Usa los valores pasados como props y Actualiza la tabla después de eliminar
            setIsOpenAlert(false); // Cierra el modal
        });
    };

    return (
        <>
            <Tooltip hasArrow label='Eliminar' placement='auto'>
                <IconButton
                    aria-label="Eliminar"
                    onClick={() => handleOpenAlert(row.id)}
                    icon={<Icon as={MdDelete} />}
                    fontSize="2xl"
                    colorScheme="red"
                    variant={'ghost'}
                    _dark={{ color: "white", _hover: { bg: "red.800" } }}
                    ml={2}
                />
            </Tooltip>
            <AlertDialog
                motionPreset='slideInBottom'
                onClose={handleCloseAlert}
                isOpen={isOpenAlert}
                isCentered
                size="xl"
            >
                <AlertDialogOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />

                <AlertDialogContent py={6} _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <Flex textAlign="center" justifyContent="center" p={2}>
                        <Icon as={AiOutlineAlert} fontSize="9xl" color="red.500" />
                    </Flex>
                    <AlertDialogHeader textAlign="center" fontSize="3xl" fontWeight={'bold'}>¿Está seguro de eliminar? </AlertDialogHeader>
                    <AlertDialogBody textAlign="center" fontSize="xl">
                        ¡No podrás revertir esto!
                    </AlertDialogBody>
                    <AlertDialogFooter justifyContent="center" fontWeight="normal">
                        <Button
                            onClick={handleCloseAlert}
                            colorScheme="red"
                            size="lg"
                            _dark={{ bg: "red.600", color: "white", _hover: { bg: "red.800" } }}
                            borderRadius="xl"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="green"
                            ml={3}
                            onClick={() => handleDelete(row.id)}
                            size="lg"
                            _dark={{ bg: "green.600", color: "white", _hover: { bg: "green.800" } }}
                            borderRadius="xl"
                        >
                            ¡SÍ BÓRRALO!
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    )
}
